import { PostsArrangedByPlatform } from "@/lib/review-fn";
import { useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import SocialCardWithImage from "./SocialCardWithImage";

type Props = {
  isPlatformSelected: boolean,
  posts: PostsArrangedByPlatform[number],
  event_id: number
  event_name: string,
  event_status: "Scheduled" | "Pending",
  isRegenerating: boolean,
  onSchedule: (id: number) => void,
  eventIndex: number
}

const PostByPlatform = ({ isPlatformSelected, posts, ...props }: Props) => {

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % posts.content.length);
  };

  const fadeVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
    exit: { opacity: 0 },
  };

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={posts.content[currentIndex].post_id}
        variants={fadeVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        transition={{ duration: 0.4 }}
      >
        <SocialCardWithImage
          isPlatformSelected={isPlatformSelected}
          onSliceChange={handleNext}
          content={posts.content[currentIndex]}
          key={posts.content[currentIndex].post_id}
          event_id={props.event_id}
          event_name={props.event_name}
          eventIndex={props.eventIndex}
          onSchedule={props.onSchedule}
          event_status={props.event_status}
          isRegenerating={props.isRegenerating}
        />
      </motion.div>
    </AnimatePresence>
  )
}

export default PostByPlatform;
